import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";

class UserProfileWillMount extends Middleware implements MiddlewareInterface {
  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    const user = this.component.props.app?.persons
                     .find(person => person?.id === this.component.props.app?.session?.user?.id);
    const settings = this.component.props.app?.settings?.user;

    if (!user) {
      return this.component.redirect("/app/dashboard/overview");
    }

    if (user?.documentAddress?.formattedAddress) {
      this.component.setState({
        documentAddress: user?.documentAddress
      })
    }

    this.component.setState({
      user: user,
      firstName: user?.firstName,
      lastName: user?.lastName,
      email: user?.email,
      phone1: user?.phone1,
      phone2: user?.phone2,
      profession: user?.profession,
      attachments: user?.attachments,
      amazonFolderName: user?.amazonFolderName,
      note: user?.note,
      mainBankAccountId: user?.mainBankAccountId,
      mainBankAccountName: user?.mainBankAccountName,
      address: user?.address,
      dateOfBirth: user?.dateOfBirth,
      placeOfBirthAddress: user?.placeOfBirthAddress,
      identityNumber: user?.identityNumber,
      identityType: user?.identityType,
      genderTypeId: user?.genderTypeId,
      languageTypeId: user?.languageTypeId,
      language: settings?.language?.iso,
      locale: settings?.locale?.iso,
      beta: settings?.beta,
      currency: settings?.currency?.getCurrencyId(),
    });
  }
}

export default new UserProfileWillMount();
